(() => {
  let sequence = 0;
  const cartState = cart => [cart?.total_price, (cart?.items || []).map(item => [item.key, item.quantity, item.line_price, item.final_line_price])];
  document.addEventListener('bellzi:cart-state', async event => {
    const page = document.querySelector('[data-cart-page]');
    const wrapper = page?.closest('[id^="shopify-section-"]');
    if (!wrapper || !event.detail?.cart) return;
    let rendered;
    try { rendered = JSON.parse(page.querySelector('[data-page-cart]').textContent); } catch { return; }
    if (JSON.stringify(cartState(rendered)) === JSON.stringify(cartState(event.detail.cart))) return;
    const revision = ++sequence;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart?section_id=' + encodeURIComponent(wrapper.id.slice('shopify-section-'.length)), {credentials:'same-origin', cache:'no-store'});
      if (!response.ok) return;
      const next = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('[data-cart-page]');
      if (!next || revision !== sequence || !page.isConnected) return;
      const nextCart = JSON.parse(next.querySelector('[data-page-cart]').textContent);
      // Preserve any merchandise quantities and order note the shopper is editing.
      const quantities = page.querySelectorAll('[name="updates[]"]');
      const nextQuantities = next.querySelectorAll('[name="updates[]"]');
      rendered.items.forEach((item, index) => {
        const input = quantities[index];
        if (!input || item.properties?._bellzi_promotion || input.value === input.defaultValue) return;
        const destination = nextCart.items.findIndex(line => line.key === item.key);
        if (destination >= 0 && nextQuantities[destination]) nextQuantities[destination].value = input.value;
      });
      const note = page.querySelector('[name="note"]');
      if (note && next.querySelector('[name="note"]')) next.querySelector('[name="note"]').value = note.value;
      page.replaceWith(next);
      document.dispatchEvent(new CustomEvent('shopify:section:load', {detail:{sectionId:wrapper.id}}));
    } catch { /* Native checkout still verifies gift quantity and price. */ }
  });
})();
